<mat-form-field *ngIf="!useChips">
  <input matInput placeholder="{{ settings?.placeholder | translate }}" [(ngModel)]="value" [disabled]="!editable || filterIsNull">
  <button mat-button *ngIf="value && editable" matSuffix mat-icon-button (click)="reset()">
    <mat-icon>close</mat-icon>
  </button>
</mat-form-field>

<div *ngIf="useChips" [ngClass]="!editable ? 'mb20' : ''">
  <div *ngIf="terms.length > 0">
    <h4>{{'ALDEN.FILTERS.CONTAINS' | translate}}</h4>
    <mat-chip-list>
      <mat-chip *ngFor="let term of terms" color="primary" selected [removable]="removable" (removed)="remove(term)" [disabled]="filterIsNull">
        {{term}}
        <button *ngIf="editable" matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
    </mat-chip-list>
  </div>
  <div *ngIf="excludedTerms.length > 0">
    <h4>{{'ALDEN.FILTERS.NOT_CONTAINS' | translate}}</h4>
    <mat-chip-list>
      <mat-chip *ngFor="let term of excludedTerms" [removable]="removable" (removed)="remove(term)" [disabled]="filterIsNull">
        {{term}}
        <button *ngIf="editable" matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
    </mat-chip-list>
  </div>
  <mat-form-field *ngIf="editable">
    <input matInput placeholder="{{ settings?.placeholder | translate }}" [(ngModel)]="value" (keyup.enter)="add()" [disabled]="!editable  || filterIsNull"/>
    <div matSuffix class="app-suffix-search-icon-wrapper" *ngIf="editable">
      <mat-icon (click)="exclude()">remove</mat-icon>
      <mat-icon (click)="add()">add</mat-icon>
    </div>
  </mat-form-field>
</div>

<div class="button-container" *ngIf="editable">
  <mat-slide-toggle *ngIf="nullable" [(ngModel)]="filterIsNull">{{'ALDEN.CUSTOM_LISTS.FILTERS.IS_NULL' | translate}}</mat-slide-toggle>

  <mat-button-toggle-group *ngIf="allowOperatorChange && terms.length + excludedTerms.length > 1" [(ngModel)]="chipOperator" [disabled]="filterIsNull">
    <mat-button-toggle value="AND"
      title="{{'ALDEN.CUSTOM_LISTS.FILTERS.OPERATOR_TOOLTIP_AND' | translate}}">{{'ALDEN.CUSTOM_LISTS.FILTERS.OPERATOR_AND' | translate}}</mat-button-toggle>
    <mat-button-toggle value="OR"
      title="{{'ALDEN.CUSTOM_LISTS.FILTERS.OPERATOR_TOOLTIP_OR' | translate}}">{{'ALDEN.CUSTOM_LISTS.FILTERS.OPERATOR_OR' | translate}}</mat-button-toggle>
  </mat-button-toggle-group>
</div>

<span class="mat-error" *ngIf="(displayError$ | async) as errorMessage">
  <b>{{errorMessage}}</b>
</span>